import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { FieldTimeOutlined } from '@ant-design/icons';
import { RibbonButton, RibbonSection, RibbonDivider } from 'common/components';
import { useGetDownloadScheduleDetail } from 'pages/reporting/hook/useScheduleDownload';
import { isEmpty } from 'lodash';
import ReportingScheduleModal from 'pages/reporting/components/ReportingScheduleModal';
const OpenSchedule = (props) => {
  const { modeData, reportId, showScheduleDownload = true } = props;
  const { reportingId } = useParams();
  const [openSchedule, setOpenSchedule] = useState(false);
  const _id = reportId || reportingId;
  const { downloadScheduleDetail } = useGetDownloadScheduleDetail({
    id: _id,
    enabled: !!_id && _id !== 'create',
  });
  const onClickOpenResult = () => {
    setOpenSchedule(true);
  };
  const disabled = reportingId === 'create' || !showScheduleDownload;
  return (
    <>
      <RibbonSection>
        <RibbonDivider />
        <RibbonButton
          disabled={disabled}
          icon={<FieldTimeOutlined />}
          label='Download Schedule'
          onClick={onClickOpenResult}
          toggle={!isEmpty(downloadScheduleDetail)}
        />
      </RibbonSection>
      <ReportingScheduleModal
        reportingId={reportId || reportingId}
        modeData={modeData}
        openSchedule={openSchedule}
        setOpenSchedule={setOpenSchedule}
      />
    </>
  );
};
export default OpenSchedule;
